module.exports = __webpack_public_path__ + "img/step2.b14c370f.png";